import { render } from "./customersView.vue?vue&type=template&id=7d955d48"
import script from "./customersView.vue?vue&type=script&lang=js"
export * from "./customersView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__